import { mergeListsById } from '@opengov/compose-app/immutable';
import {
  EReportCreatedByFitler,
  EReportSortOption,
  EReportViewOption,
  EReportVisibilityFilter,
  IReportGalleryFilters
} from '@opengov/reporting-types';
import { ReportGalleryFilters } from '../report/records';

export const createdByFilterLocalStorageKey = 'reportgallery.filters.createdBy';
export const visibilityFilterLocalStorageKey = 'reportgallery.filters.visibility';
export const sortOptionLocalStorageKey = 'reportgallery.filters.sort';
export const galleryViewOptionLocalStorageKey = 'reportgallery.filters.view';
export const showStandardReportsLocalStorageKey = 'reportgallery.showStandardReports';
export const COA_BANNER_HEIGHT = 47;
export const PSP_NAV_BAR_ADJUSTMENT = 52;

export const mergeReportListsById = (a, b) => (b && b.length > 0 ? mergeListsById(a, b) : b);
export const mergeReportCreatorListByUuid = (a, b) => a.filter((ar) => !b.find((br) => br.uuid === ar.uuid)).concat(b);

export const getReportGalleryFiltersFromLocalStorage = () => {
  const storage = window.localStorage;
  const defaultFilters = ReportGalleryFilters({ isLoaded: true });

  if (storage) {
    const createdByFilter =
      EReportCreatedByFitler[
        storage.getItem(createdByFilterLocalStorageKey) as unknown as keyof typeof EReportCreatedByFitler
      ] || defaultFilters.createdBy;

    const visibilityFilter =
      EReportVisibilityFilter[
        storage.getItem(visibilityFilterLocalStorageKey) as unknown as keyof typeof EReportVisibilityFilter
      ] || defaultFilters.visibility;

    const sortOption =
      EReportSortOption[storage.getItem(sortOptionLocalStorageKey) as unknown as keyof typeof EReportSortOption] ||
      defaultFilters.sort;

    const viewOption =
      EReportViewOption[
        storage.getItem(galleryViewOptionLocalStorageKey) as unknown as keyof typeof EReportViewOption
      ] || defaultFilters.view;

    return ReportGalleryFilters({
      ...defaultFilters.toObject(),
      createdBy: createdByFilter,
      visibility: visibilityFilter,
      sort: sortOption,
      view: viewOption,
      isLoaded: true
    });
  }

  return defaultFilters;
};

export const setReportGalleryFiltersToLocalStorage = (filters: IReportGalleryFilters) => {
  const storage = window.localStorage;
  if (storage) {
    storage.setItem(createdByFilterLocalStorageKey, filters.createdBy);
    storage.setItem(visibilityFilterLocalStorageKey, filters.visibility);
    storage.setItem(sortOptionLocalStorageKey, filters.sort);
    storage.setItem(galleryViewOptionLocalStorageKey, filters.view);
  }
};

export const getReportGalleryshowStandardReportsFromLocalStorage: () => boolean = () => {
  const storage = window.localStorage;
  let show = true;
  if (storage) {
    const storedVal = storage.getItem(showStandardReportsLocalStorageKey);
    if (storedVal) {
      show = storedVal === 'true';
    }
  }
  return show;
};

export const setReportGalleryshowStandardReportsFromLocalStorage: (boolean) => void = (val) => {
  const storage = window.localStorage;
  if (storage) {
    storage.setItem(showStandardReportsLocalStorageKey, val ? 'true' : 'false');
  }
};

export enum ViewModal {
  Delete = 'deleteViewModal',
  SaveAsNew = 'saveAsViewModal',
  UpdateViewDetails = 'updateViewDetails',
  Update = 'updateModal',
  None = 'none'
}

export const MuiToastTypes = {
  FAILURE: 'FAILURE' as const,
  SUCCESS: 'SUCCESS' as const,
  WARNING: 'WARNING' as const,
  INFO: 'INFO' as const,
  ERROR: 'ERROR' as const
};
export type IMuiToastTypes = keyof typeof MuiToastTypes;
export interface IToastMuiProps {
  className?: string;
  bodyText?: string;
  headerText?: string;
  actionText?: string;
  type?: IMuiToastTypes;
  dismissible?: boolean;
  dataTest?: string;
  handleAction?(): void;
  handleClose?(): void;
  showLoader?: boolean;
}
export const toastSeverity = (severity: IMuiToastTypes | undefined) => {
  switch (severity) {
    case MuiToastTypes.FAILURE:
      return 'error';
    case MuiToastTypes.SUCCESS:
      return 'success';
    case MuiToastTypes.WARNING:
      return 'warning';
    case MuiToastTypes.INFO:
      return 'info';
    default:
      return 'success';
  }
};
export enum ValidationStates {
  Success = 'Success',
  Error = 'Error',
  None = 'None'
}

export function getWorkspaceSidebarMarginTop({
  isPsp,
  isCoAMigrationEnabled
}: {
  isPsp: boolean;
  isCoAMigrationEnabled: boolean;
}) {
  if (isPsp && isCoAMigrationEnabled) {
    return PSP_NAV_BAR_ADJUSTMENT + COA_BANNER_HEIGHT;
  }

  if (isPsp) {
    return PSP_NAV_BAR_ADJUSTMENT;
  }

  if (isCoAMigrationEnabled) {
    return COA_BANNER_HEIGHT;
  }

  return 0;
}
